import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import UploadField from 'containers/Mail/FormFields/UploadField';
import { useValidateCSVMail } from 'query/mail';

const UploadRecipients = ({ setIsCsvValid, setTotalRows, disabled }) => {
  const { watch } = useFormContext();

  const templateId = watch('templateId');
  const isMultiMode = watch('isMultiMode');
  const forceChoose = watch('force_choose');
  const files = watch('csvFiles');

  const { data, isFetching } = useValidateCSVMail(
    files[0],
    templateId,
    isMultiMode,
    forceChoose,
  );

  useEffect(() => {
    setIsCsvValid && setIsCsvValid(data?.valid);
    setTotalRows && setTotalRows(data?.totalRows || 0);
  }, [data]);

  return (
    <UploadField data={data} disabled={disabled} isFetching={isFetching} />
  );
};

export default UploadRecipients;
